import {Translate} from 'react-redux-i18n';
import {useHistory} from 'react-router-dom';
import {Icon} from 'front-onceforall-core';
import authenticationService from '../../../services/authentication/AuthenticationService';
import {MANAGE_PROJECT_PERMISSION} from '../../../utils/constant';

function CreateProjectButtonView() {
  const history = useHistory();

  if (!authenticationService.roles().hasPermission(MANAGE_PROJECT_PERMISSION)) {
    return null;
  }

  return (
    <button
      type="button"
      className="large cta flex-container"
      onClick={() => history.push('/projects/new')}
    >
      <Icon icon="folder-plus"/>
      <Translate value="project.create.button"/>
    </button>
  );
}

export default CreateProjectButtonView;
